export interface CashflowScoreSlice {
  cashflowPage: number;
  setCashflowPage: (page: number) => void;
}

export const createCashflowScoreSlice = (set: any): CashflowScoreSlice => ({
  cashflowPage: 1,
  setCashflowPage: (cashflowPage) => set({ cashflowPage }),
});
